import React from 'react';
import './LowboyTimesheet.scss';
import { Button, Card, CardBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faLock,
    faPaperPlane,
    faSave,
    faThumbsUp,
} from '@fortawesome/free-solid-svg-icons';
import { isLowboyTimesheetValid } from './LowboyTimesheet';
import LowboyTimesheetRejectionButton from './LowboyTimesheetRejectionButton';
import { TimesheetStatus } from '../timesheet/Timesheet';

export default class LowboyTimesheetActionBar extends React.Component {
    isApproveButtonVisible = () => {
        const { isAdmin, isTimesheetApprover, lowboyTimesheet, anyChanges } =
            this.props;

        if (!isAdmin || anyChanges || !lowboyTimesheet) {
            return false;
        }

        if (!isTimesheetApprover) {
            return (
                lowboyTimesheet.timesheetStatusId < TimesheetStatus.Validated
            );
        }

        return lowboyTimesheet.timesheetStatusId < TimesheetStatus.Approved;
    };

    getCanEnterEditMode = () => {
        const { lowboyTimesheet, isAdmin, isTimesheetApprover, adminEditMode } =
            this.props;

        if (
            !lowboyTimesheet ||
            !isAdmin ||
            adminEditMode ||
            lowboyTimesheet.timesheetStatusId == TimesheetStatus.Rejected
        ) {
            return false;
        }

        if (isTimesheetApprover) {
            return (
                lowboyTimesheet.timesheetStatusId <= TimesheetStatus.Validated
            );
        }

        return lowboyTimesheet.timesheetStatusId <= TimesheetStatus.Submitted;
    };

    render() {
        const {
            saving,
            loading,
            onSave,
            lowboyTimesheet,
            onSubmit,
            anyChanges,
            isAdmin,
            onApprove,
            isTimesheetApprover,
            isReadOnly,
            adminEditMode,
            onToggleAdminEditMode,
        } = this.props;

        if (
            loading ||
            (!isAdmin && isReadOnly) ||
            (lowboyTimesheet &&
                lowboyTimesheet.timesheetStatusId >= TimesheetStatus.Exported)
        ) {
            return null;
        }

        const isValid = isLowboyTimesheetValid(lowboyTimesheet);
        const saveColor = anyChanges ? 'success' : 'primary';
        const submitColor = isValid ? 'success' : 'primary';
        const approveButtonVisible = this.isApproveButtonVisible();
        const canEnterEditMode = this.getCanEnterEditMode();

        return (
            <>
                <Card className="mt-3">
                    <CardBody className="d-flex fg-3">
                        <div className="w-25">
                            <Button
                                size="xl"
                                color={saveColor}
                                disabled={saving || !anyChanges}
                                onClick={onSave}
                                outline={!anyChanges}
                                hidden={!anyChanges && isAdmin}
                                className="w-100"
                            >
                                <FontAwesomeIcon
                                    icon={faSave}
                                    className="mr-2"
                                />{' '}
                                Save Timesheet
                            </Button>

                            <LowboyTimesheetRejectionButton {...this.props} />
                        </div>

                        {!isAdmin &&
                            (lowboyTimesheet.timesheetStatusId ==
                                TimesheetStatus.New ||
                                lowboyTimesheet.timesheetStatusId ==
                                    TimesheetStatus.Rejected) && (
                                <Button
                                    size="xl"
                                    color={submitColor}
                                    disabled={saving || !isValid}
                                    outline={!isValid}
                                    className="w-100"
                                    onClick={onSubmit}
                                >
                                    <FontAwesomeIcon
                                        icon={faPaperPlane}
                                        className="mr-2"
                                    />
                                    {lowboyTimesheet.timesheetStatusId ==
                                        TimesheetStatus.New && <>Submit</>}
                                    {lowboyTimesheet.timesheetStatusId ==
                                        TimesheetStatus.Rejected && (
                                        <>Resubmit</>
                                    )}{' '}
                                    Timesheet
                                </Button>
                            )}

                        {canEnterEditMode && (
                            <Button
                                className="w-50 mr-auto"
                                color="warning"
                                type="button"
                                outline={true}
                                onClick={onToggleAdminEditMode}
                            >
                                <FontAwesomeIcon
                                    icon={faLock}
                                    className="mr-2"
                                />
                                Enable Edit Mode
                            </Button>
                        )}

                        {isAdmin && !adminEditMode && approveButtonVisible && (
                            <Button
                                size="xl"
                                color="success"
                                disabled={saving}
                                className="w-50"
                                onClick={onApprove}
                            >
                                <FontAwesomeIcon
                                    icon={faThumbsUp}
                                    className="mr-2"
                                />

                                {isTimesheetApprover && <>Approve</>}
                                {!isTimesheetApprover && <>Mark As Valid</>}
                            </Button>
                        )}
                    </CardBody>
                </Card>
            </>
        );
    }
}
